import * as $ from "jquery";
export class Helper {
    static getCategoryChecboxValues(name, domId) {
        var element;
        let result = {};
        element = $(' [name=' + name + ']:checked');
        if (domId) {
            element = $('#' + domId) + ' [name=' + name + ']:checked';
        }

        let v: any = [];
        element.each(function () {
            v =  $(this).val();
            let re = /%20/gi;  
            v=v.replace(re, " "); 
            let category = JSON.parse(v);
            result[category["id"]] = category;
        });

        return JSON.stringify(result);
    }
    static categoryJsonText(checkbox){
        let str = '', name = '',j=0;
      
            var result = this.getCategoryChecboxValues(checkbox,'');
            $.each(JSON.parse(result), function(k, v) {
                name = (v.base === '') ? v.name : v.base + '~' + v.name;
                j=j + 1;
                str += '<span style="display:block;">' + j + '. ' + unescape(name.replace(/\~/g, ' >> ')) + '</span>';
            });
       
        return str;
    }
}